/**
 * The "In stock" cell — `purchasing-main.png`.
 *
 * Reads "240 / 691" over a bar. The bar is the thing the eye uses: full green
 * covered, part amber, empty red. Numbers alone make you divide in your head
 * for twelve rows.
 */
import { formatNumber } from '../lib/format.js'
import { cn } from '../lib/cn.js'

export function StockBar({
  available, needed, unit,
}: {
  available: number
  needed: number
  unit: string
}) {
  // Negative available is real — more is reserved than the yard holds — and
  // the bar shows it as empty rather than pretending.
  const ratio = needed > 0 ? Math.min(1, Math.max(0, available / needed)) : 1
  const covered = ratio >= 1
  const none = available <= 0

  return (
    <span className="flex flex-col items-end gap-1">
      <span className="text-body tnum">
        <span className={cn('font-bold', none ? 'text-danger' : 'text-text')}>
          {formatNumber(available)}
        </span>
        <span className="text-text-faint"> / {formatNumber(needed)}</span>
      </span>
      <span
        role="img"
        aria-label={`${formatNumber(available)} of ${formatNumber(needed)} ${unit} on hand`}
        className="block h-1.5 w-[104px] overflow-hidden rounded-chip bg-progress-track"
      >
        <span
          className={cn('block h-full rounded-chip',
            covered ? 'bg-accent' : none ? 'bg-danger' : 'bg-warn')}
          style={{ width: `${Math.max(ratio * 100, none ? 0 : 6)}%` }}
        />
      </span>
    </span>
  )
}
